import { render, staticRenderFns } from "./create-items.vue?vue&type=template&id=1c62eaac"
import script from "./create-items.vue?vue&type=script&lang=js"
export * from "./create-items.vue?vue&type=script&lang=js"
import style0 from "./create-items.vue?vue&type=style&index=0&id=1c62eaac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports